import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, timeout} from 'rxjs';
import {HelperService} from '../services/helper.service';

const DEFAULT_TIMEOUT = 30000;

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    constructor(private helperService: HelperService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let timeOut = DEFAULT_TIMEOUT;
        if (!req.headers.get('isWebserviceAvailableCheck')) {
            timeOut = this.helperService.isWebServiceAvailable() && navigator.onLine ? Number(req.headers.get('timeout')) || DEFAULT_TIMEOUT : 100;
            req.headers.delete('timeout');
            req.headers.append('timeout', timeOut.toString());
        }
        return next.handle(req).pipe(timeout(timeOut));
    }
}
